module.exports = __webpack_public_path__ + "media/images/ipaymoney1-165890ef78c23e04d29a493be1e4b7af.svg";